export const enum BlockchainEventWatcherEnum {
    Transfer='Transfer',
    TransferFrom='TransferFrom',
    TransferTo='TransferTo',
    IdentityValidate='URIValidate',
    IdentityUpdate ='URIUpdated',
    MessageReceive='MessageReceive'
}
